import React from 'react';
import PropTypes from 'prop-types';
import { HrFlexContainer } from '@components/styles/hr-styles';
import { HrButton } from '@components/button/button';
import {
  BackNavigationButton,
  CancelButton,
  NextNavigationButton,
  SaveDraftButton
} from '@/vacancy_request/components/template-request-form/navigation-buttons/components';

const NavigationButtons = (props) => {
  const { activeTab, onNavigateBack, onNavigateForward, isSubmitting, mode, canStoreDraftVacancy, submitDraft } = props;

  const renderNavigationButtons = () => {
    switch (activeTab) {
      case 0:
        return (
          <>
            <CancelButton />

            <HrFlexContainer gap='16px' justifyContent='flex-end'>
              {canStoreDraftVacancy && <SaveDraftButton isSubmitting={isSubmitting} submitDraft={submitDraft} />}
              <NextNavigationButton onNavigateNext={onNavigateForward} />
            </HrFlexContainer>
          </>
        );
      case 1:
        return (
          <>
            <CancelButton />

            <HrFlexContainer gap='16px' justifyContent='flex-end'>
              {canStoreDraftVacancy && <SaveDraftButton isSubmitting={isSubmitting} submitDraft={submitDraft} />}
              <BackNavigationButton onNavigateBack={onNavigateBack} />
              <NextNavigationButton onNavigateNext={onNavigateForward} />
            </HrFlexContainer>
          </>
        );
      case 2:
        return (
          <>
            <CancelButton />

            <HrFlexContainer gap='16px' justifyContent='flex-end'>
              {canStoreDraftVacancy && <SaveDraftButton isSubmitting={isSubmitting} submitDraft={submitDraft} />}
              <BackNavigationButton onNavigateBack={onNavigateBack} />
              {mode === 'create' && (
                <HrButton type='submit' category='primary' size='large' text='Crear' disabled={isSubmitting} />
              )}
              {mode === 'edit' && (
                <HrButton type='submit' category='primary' size='large' text='Actualizar' disabled={isSubmitting} />
              )}
            </HrFlexContainer>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <HrFlexContainer flexWrap='nowrap' justifyContent='space-between' padding='32px 0 0 0'>
      {renderNavigationButtons()}
    </HrFlexContainer>
  );
};

NavigationButtons.propTypes = {
  activeTab: PropTypes.number.isRequired,
  onNavigateBack: PropTypes.func.isRequired,
  onNavigateForward: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired,
  canStoreDraftVacancy: PropTypes.bool.isRequired,
  submitDraft: PropTypes.func.isRequired
};

export default NavigationButtons;
